module.exports = "<div *ngIf=\"currentUser\">\n    <a [routerLink]=\"['/account']\">{{ currentUser.displayName }}</a>\n    <button (click)=\"logout()\">Logout</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/auth/userbar.component.html
// module id = ../../../../../src/app/auth/userbar.component.html
// module chunks = main